import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { NotificationService } from 'app/_services/notification.service';
import { Globals } from 'app/_globals';
import { CookieService } from 'ngx-cookie-service';
import { StoreService } from '../../_services/store.service';

@Component({
  selector: 'app-store-settings',
  templateUrl: './store-settings.component.html',
  styleUrls: ['./store-settings.component.css'],
})
export class StoreSettingsComponent implements OnInit {
  tabitems: any = [];

  storeId: any;
  selectedStore: any;
  cookieStore: any;
  storeForm: FormGroup;

  role: any;
  routeRole: any;

  constructor(
    public fb: FormBuilder,
    public activatedRoute: ActivatedRoute,
    public loader: LoadingBarService,
    public notificationService: NotificationService,
    public globals: Globals,
    public cookieService: CookieService,
    public router: Router,
    public _storeService: StoreService
  ) {
    const hasCurrentStore = cookieService.check('currentStore');
    if (hasCurrentStore) {
      this.cookieStore = JSON.parse(cookieService.get('currentStore'));
      this.storeId = this.cookieStore.id;
    } else {
      this.router.navigate(['/' + this.globals.user.routeRole + '/select-store']);
    }

    this.role = globals.user.role;
    this.routeRole = globals.user.routeRole;

    this.tabitems = [
      { path: '/' + this.routeRole + '/store/details', title: 'Details' },
      { path: '/' + this.routeRole + '/store/location', title: 'Location' },
      { path: '/' + this.routeRole + '/store/opening-times', title: 'Ordering Times' },
      { path: '/' + this.routeRole + '/store/media', title: 'Media' },
      { path: '/' + this.routeRole + '/store/payment-setup', title: 'Payment Setup' },
      { path: '/' + this.routeRole + '/store/pos-setup', title: 'POS Setup' },
      { path: '/' + this.routeRole + '/store/services', title: 'Services' },
      { path: '/' + this.routeRole + '/store/settings', title: 'Settings' },
    ];
  }

  ngOnInit() {
    this.getStore(this.storeId);
  }

  // Get Store by id
  public getStore(id) {
    this.storeId = 1;
    this.selectedStore = {
      id: 1,
      name: 'Church Street SPAR',
      addressLine1: 'Church St. SPAR',
      town: 'Cookstown',
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/indi-store/settings/store-settings.component.ts